export const getMaxDevicesForLayoutType = (type: string): number => {
    switch (type) {
        case '2x2':
            return 4;
        case '1х5':
            return 6;
        case '3х4':
            return 7;
        case '3х3':
            return 9;
        case '2х8':
            return 10;
        case '1х12':
            return 13;
        case '4х4':
            return 16;
        case '1х7':
            return 8;
        default:
            return 9; // default to 3x3
    }
};
